import classNames from "classnames";

export const TopPlaceImageSkeleton = () => {
    return (
        <div
            className={classNames({
                'relative mb-4 bg-slate-200 overflow-hidden': true,
                'animate-pulse': true,
            })}
        >
            <div
                className={classNames({
                    'bg-neutral-100 border-r border-b border-zinc-200': true,
                    'absolute z-10 top-0 left-0 w-[74px] h-[74px]': true,
                    'p-3 bg-neutral-100 flex justify-between items-center': true,
                })}
            >
                <span className={classNames({
                    'w-full text-center text-sky-950 text-[27px]': true,
                    'font-bold leading-10 tracking-wide': true,
                })}/>
            </div>
            <div className="relative w-full h-56 md:h-[420px] overflow-hidden"/>
        </div>
    );
}